import { Pipe, PipeTransform } from '@angular/core';
import { InstituicaoNaturezaEnum } from '../components/api/models/institutionNaturezaEnum';

@Pipe({
  name: 'enumToString'
})

export class EnumToStringPipe implements PipeTransform {

  transform(value: InstituicaoNaturezaEnum | string | undefined): string {
    if (value === undefined || value === null) {
      return 'Desconhecido';
    }
    return TipoNaturezaEnumDescriptions[value as InstituicaoNaturezaEnum] || 'Desconhecido';
  }

}

export const TipoNaturezaEnumDescriptions: { [key in InstituicaoNaturezaEnum]: string } = {
  [InstituicaoNaturezaEnum.Publica]: "Pública",
  [InstituicaoNaturezaEnum.Privada]: "Privada",
};
